// extracted by mini-css-extract-plugin
export default {"loading":"AppRouter_loading__ABFL4"};